import React from 'react'
import Img from 'src/components/shared/Img'

const BBBWidget = () => {
  return (
    <a
      href="https://www.bbb.org/us/ca/san-mateo/profile/debt-relief-services/freedom-debt-relief-llc-1116-65019"
      target="_blank"
      rel="nofollow"
      data-testid="scam-bbb-link"
    >
      <Img
        src="/next-assets/brand-pages/partners/bbb-scam.webp"
        alt="Freedom Debt Relief LLC BBB Business Review"
        width={208}
        height={100}
        className="h-16 w-52 lg:mb-0"
        layout="intrinsic"
        dataTestId="scam-bbb-logo"
      />
    </a>
  )
}

export default BBBWidget
